import {
  ActionButtonProps,
  Box,
  ColorOptions,
  convertHexToRGBA,
  Form,
  Loader,
  ModBox,
  SpacerNew,
  Text,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import * as React from 'react'
import { FC, useCallback, useEffect, useState } from 'react'
import { Linking } from 'react-native'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { loginStrings } from '../../../data/static/strings'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { APIEndPoints } from '../../../network/APIEndpoints'
import { useIsMobile } from '../../../util/useFontSize'
import {
  clearSession,
  Colors,
  getSelectedDate,
  isSessionValid,
  storeData,
  useWindowDimensions,
} from '../../../util/util'
import { ResendOtp } from '../../Otp/ResendOtp'
import { getEmailLoginFormData, loginForm } from '../FormDataForMobile'
import { styles } from '../styles'
import ShowHidePassword from './ShowHidePassword'

interface LoginCardProps {
  hide?: boolean
  getMobileNumber: (mobNumber: string) => void
  deeplinkPath: string
}

const getInitValues = (mNumber: string, emailId: string, password: string): any => {
  return {
    mobileNumber: mNumber && mNumber.length > 0 && mNumber.length <= 10 ? mNumber : '',
    password: password,
    email: emailId,
  }
}

const LoginCardMobileWeb: FC<LoginCardProps> = ({ hide, getMobileNumber, deeplinkPath }: LoginCardProps) => {
  const [showApiError, setShowApiError] = useState(false)
  const {
    sessionData,
    verifyCredentials,
    mobileNumber,
    updateMobile,
    updateDatesInAllScreens,
    getAllMerchantMetaData,
    returnJfsUserIdAfterLogin,
    merchantData,
    sendOtpAync,
    validateOtpAync,
    isEmailLogin,
    setIsEmailLogin,
    storedEmailId,
  } = useStores((root) => ({
    sessionData: root.user.session,
    verifyCredentials: root.user.session.verifyCredentials,
    mobileNumber: root.settings.metaData.mobileNumber,
    updateMobile: root.settings.metaData.updateMobileNumber,
    updateDatesInAllScreens: root.updateDatesInAllScreens,
    getAllMerchantMetaData: root?.user?.getAllMerchantMetaData,
    returnJfsUserIdAfterLogin: root.user.session.returnJfsUserIdAfterLogin,
    merchantData: root.user.merchantData(),
    sendOtpAync: root.user.session.sendOtpAync,
    validateOtpAync: root.user.session.validateOtpAync,
    isEmailLogin: root.user.session.isEmailLogin,
    setIsEmailLogin: root.user.session.setIsEmailLogin,
    storedEmailId: root.user.session.emailId,
  }))

  const [login, { state, data }] = useLazyApiData(verifyCredentials)
  const [searchAllMerchants, searchMerchantHandler] = useLazyApiData(getAllMerchantMetaData)
  const [lazySendOtp, sendOtpHandler] = useLazyApiData(sendOtpAync)
  const [lazyValidateOtp, validateOtpHandler] = useLazyApiData(validateOtpAync)

  const navigation = useNavigation()
  const [hidePassword, setHidePassword] = useState(false)
  const [password, setPassword] = useState('')
  // const [isEmailLogin, setIsEmailLogin] = useState(false)
  const [currentStep, setCurrentStep] = useState(0)

  const formRef = React.useRef(null)

  const viewPortWidth = useWindowDimensions()

  const isMobile = useIsMobile()
  const updateSelectedDateToCurrentDate = useCallback(() => {
    const updatedDateObj = {
      fromDate: getSelectedDate(1),
      toDate: new Date(Date.now()),
      position: {
        top: 0,
        left: 0,
        visible: false,
      },
      dateLabel: 'Today',
    }
    updateDatesInAllScreens(updatedDateObj, isMobile)
  }, [updateDatesInAllScreens])

  useEffect(() => {
    if (searchMerchantHandler?.state === 'fulfilled' && merchantData?.length > 0) {
      console.log('searchMerchantHandler', searchMerchantHandler)
      const paths: any = {
        'initiate-refunds': Routes.RECENTS,
        'transactions/initiate-refunds': Routes.TRANSACTIONS,
        'transactions-details': Routes.TRANSACTIONS,
        'bulkrefund/report': Routes.BULK_REFUND,
        'bulkrefund/summary': Routes.BULK_REFUND,
        'refunds/initiate-refunds': Routes.REFUNDS,
        'subscriptions/initiate-refunds': Routes.SUBSCRIPTIONS,
        'refund-reports': Routes.REFUNDS,
        'bulk-refund': Routes.BULK_REFUND,
        'payment-links': Routes.PAYMENT_LINKS,
      }
      const mDeeplinkedPath = deeplinkPath !== 'login' ? paths[deeplinkPath] || deeplinkPath : Routes.RECENTS
      navigation.reset({
        index: 0,
        routes: [{ name: Routes.ROOTSCREEN, params: { path: mDeeplinkedPath } }],
      })
      updateSelectedDateToCurrentDate()
    } else if (
      (searchMerchantHandler?.state === 'fulfilled' && merchantData?.length < 1) ||
      searchMerchantHandler?.state === 'rejected'
    ) {
      clearSession()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantData.length, searchMerchantHandler?.state])

  useEffect(() => {
    if (state === 'fulfilled' && typeof data !== 'undefined') {
      if (isSessionValid(sessionData)) {
        const validJfsUserId = returnJfsUserIdAfterLogin()
        if (validJfsUserId?.length > 2) {
          searchAllMerchants(validJfsUserId)
        }
      }
    }
    if (state === 'rejected') {
      setShowApiError(true)
    }
  }, [data, returnJfsUserIdAfterLogin, searchAllMerchants, sessionData, state])

  useEffect(() => {
    if (validateOtpHandler?.state === 'fulfilled') {
      if (isSessionValid(sessionData)) {
        const validJfsUserId = returnJfsUserIdAfterLogin()
        if (validJfsUserId?.length > 2) {
          searchAllMerchants(validJfsUserId)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOtpHandler?.state])

  useEffect(() => {
    if (sendOtpHandler?.state === 'fulfilled') {
      setCurrentStep(1)
    }
  }, [sendOtpHandler?.state])

  if (hide) {
    return null
  }

  const isPasswordVisible = (isVisible: boolean): void => {
    setHidePassword(isVisible)
  }

  const handleOnPress = () => {
    if (!isEmailLogin) {
      if (currentStep === 0) {
        setShowApiError(false)
        updateMobile(formRef?.current?.getValues()?.mobileNumber)
        setCurrentStep(1)
      } else {
        handleLoginPress(formRef?.current?.getValues())
      }
    } else {
      if (currentStep === 0) {
        lazySendOtp(formRef?.current?.getValues()?.email)
      } else {
        lazyValidateOtp(formRef?.current?.getValues()?.email, formRef?.current?.getValues()?.otp)
      }
    }
  }

  const renderActionButtons = ({
    defaultActionButtonOnSubmit,
    values,
    isValid,
    isCurrentFormValid,
    title,
  }: ActionButtonProps): React.ReactElement => {
    const isLoading = [state, sendOtpHandler?.state, validateOtpHandler?.state, searchMerchantHandler?.state].includes(
      'pending',
    )
    return (
      <>
        <Box
          {...themedStyle.loginBtnContainerStyle}
          bg={
            !isCurrentFormValid || isLoading
              ? (convertHexToRGBA(Colors.PRIMARY as ColorOptions, 50) as ColorOptions)
              : (Colors.PRIMARY as ColorOptions)
          }
          onPress={handleOnPress}
          testID="action-btn"
          disabled={!isCurrentFormValid || isLoading}
          h={48}
          justify={'center'}
          borderRadius={24}
          underlayColor={Colors.PRIMARY as ColorOptions}>
          <Text hide={isLoading} color={'WHITE'} fontFamily={'JioType-Bold'} fontSize={16} letterSpacing={-0.08}>
            {title}
          </Text>
          {isLoading && <Loader color={'WHITE'} />}
        </Box>
        <ModBox
          mt={16}
          paddingBottom={4}
          alignItems={'center'}
          show={currentStep === 0}
          onPress={() => setIsEmailLogin(!isEmailLogin)}
          underlayColor={'TRANSPARENT'}>
          <Text color={Colors.PRIMARY} fontFamily="jioType-medium">
            {`Login Using ${isEmailLogin ? 'Mobile No.' : 'Email'}`}
          </Text>
        </ModBox>
        <ModBox show={isEmailLogin && currentStep === 1}>
          <ResendOtp count={30} email={values?.email} color="BLUE" type="EMAIL_OTP" />
        </ModBox>
        <SpacerNew direction="vertical" size={16} />
        <Text
          color={convertHexToRGBA(Colors.BLACK as ColorOptions, 65) as ColorOptions}
          fontFamily={'JioType-Medium'}
          fontSize={12}
          letterSpacing={-0.06}
          textAlign={'center'}>
          {'By clicking, I agree to JioPay Business (Jio Payment Solutions Limited)'}
          <Text
            title={'Terms & Conditions'}
            color={'BLACK_21'}
            fontFamily={'JioType-Bold'}
            fontSize={12}
            letterSpacing={-0.06}
            testID="termsAndCondition"
            onPress={() => Linking.openURL(APIEndPoints.privactPolicy)}
            textDecorationLine={'underline'}
          />
        </Text>
      </>
    )
  }

  const handleLoginPress = (values: any): void => {
    if (values.mobileNumber && values.password) {
      setPassword(values.password)
      login(values.mobileNumber, values.password)
      updateMobile(values.mobileNumber)
      storeData(loginStrings.userMobileNumber, values.mobileNumber)
      getMobileNumber(values.mobileNumber)
    }
  }

  const leftComp = (
    <Text
      title={'+91'}
      fontFamily={'JioType-Medium'}
      fontSize={24}
      lineHeight={32}
      color={Colors.BLACK_14 as ColorOptions}
    />
  )
  const onChangeMobilePress = () => setCurrentStep(0)
  const onChangeEmailPress = () => setCurrentStep(0)
  const getFormData = (): any[] => {
    const initialFormData = [
      ...loginForm(
        <ShowHidePassword
          isDisabled={state === 'pending'}
          isPasswordVisible={isPasswordVisible}
          showPassword={hidePassword}
        />,
        hidePassword,
        state === 'pending',
        leftComp,
        handleLoginPress,
        onChangeMobilePress,
        data,
        showApiError,
        null,
        null,
        'en',
      ),
    ]
    return isEmailLogin ? getEmailLoginFormData({ onChangeEmailPress }) : initialFormData
  }

  const themedStyle = styles(viewPortWidth)
  const formData = getFormData()

  return (
    <Box
      {...themedStyle.loginFormCard}
      minWidth={viewPortWidth > 432 ? 320 : viewPortWidth - 36}
      paddingVertical={32}
      paddingHorizontal={24}>
      <Text fontFamily={'JioType-Black'} fontSize={24}>
        {loginStrings.login}
      </Text>
      <Form
        initialValues={getInitValues(mobileNumber, storedEmailId, password)}
        formData={formData}
        container={DefaultFormContainer}
        actionButtons={renderActionButtons}
        ref={formRef}
        initialStep={formData?.[currentStep]?.key}
      />
    </Box>
  )
}
export default LoginCardMobileWeb
